angular.module('Directives').directive('richTooltip', function() {
    return {
      restrict: 'E',
      scope: {
        iconName: '@',                  // Material icon name, e.g. 'error', 'info', etc.
        iconColor: '@',                 // Icon color
        iconFilled: '@',                // 'true' or 'false' for filled style
        tooltipTitle: '@',              // Popover title
        tooltipText: '@',               // Popover main text
        tooltipLink: '@?',              // Optional link text
        tooltipLinkAction: '&?',        // Optional link action
        tooltipLeftPosition: '@?',      // Optional left position adjustment
        tooltipTopPosition: '@?'        // Optional top position adjustment
      },
      templateUrl: 'rich-tooltip.tpl.html',
      controller: ['$scope', function($scope) {
        $scope.dispatchChatBox = function() {
          document.dispatchEvent(
            new CustomEvent('_chat-box', {
              detail: {
                openChatBox: true,
              },
            })
          );
        };
      }],
      controllerAs: 'vm',
      bindToController: true
    };
});